import { ThemeProvider, Mode, ThemeName } from '@fcamna/shared-component-foundations';
import { PageHeader } from '../../components/Header/Header';
import { Card, CardOrientationEnum, CardTypeEnum, RatioPropEnum } from '../../ui/Card';
import { useUniversalContext } from '@cxc/react-universal-components';
import { getCountry, EU9_LANGUAGES } from '../../utils/locale';
import './EULandingPageView.scss';
import { CardContainer } from '../../components/CardContainer/CardContainer';
import { useAemEuLandingPage } from '../../hooks/useAemEuLandingPage';
import useAnalytics from '../../analytics/useAnalytics';
import { ANALYTICS_PAGES } from '../../analytics/analytics.constants';
import { logAnalytics } from '../../analytics/helpers';
import DocumentHead from '../../components/DocumentHead/DocumentHead';
import { TCardContainerAemProp } from '../../model/AemDataProps';
import DisclosureContainer from '../../components/DisclosureContainer/DisclosureContainer';
import '../../styles/common.scss';

const EULandingPageView = () => {
  const { language } = useUniversalContext();
  const country = getCountry(language);
  useAnalytics(ANALYTICS_PAGES.EU_LANDING_PAGE);
  logAnalytics(ANALYTICS_PAGES.EU_LANDING_PAGE);

  const {
    seoAemProps,
    sectionOneAemProps,
    sectionTwoAemProps,
    sectionThreeAemProps,
    cardCollectionOneAemProps,
    cardCollectionTwoAemProps,
    imageVideoCardAemProps,
    disclosureContainerAemProps,
  } = useAemEuLandingPage(country, language);

  const isAemLoaded =
    !!sectionOneAemProps &&
    !!sectionTwoAemProps &&
    !!sectionThreeAemProps &&
    !!cardCollectionOneAemProps &&
    !!cardCollectionTwoAemProps &&
    !!imageVideoCardAemProps &&
    !!seoAemProps;

  const updateCardCollectionTwoAemProps = (cardContainerAemProps: TCardContainerAemProp) => {
    // Remove the Commercial Vehicle Showroom Card from EU9 markets since /fleet-vehicles is not available in those regions.
    const { cardsReference } = cardContainerAemProps;
    if (EU9_LANGUAGES.includes(language) && cardsReference.length === 7) {
      cardsReference.pop();
    }
    return cardContainerAemProps;
  };

  return (
    isAemLoaded && (
      <ThemeProvider themeName={ThemeName['FORD_PRO']} mode={Mode.LIGHT_MODE}>
        <DocumentHead aemSeoProps={{ ...seoAemProps }} />
        {/*section 1*/}
        <PageHeader aemHeaderProps={{ ...sectionOneAemProps }} className="page-header" />

        <div>
          <Card
            cardAemProp={imageVideoCardAemProps}
            ratioProp={RatioPropEnum.SixteenToNine}
            cardType={CardTypeEnum.Ghost}
            orientationProp={CardOrientationEnum.Horizontal}
            className={'custom-class'}
          />
        </div>

        {/*section2*/}
        <PageHeader aemHeaderProps={{ ...sectionTwoAemProps }} className="section-header" />
        <div className="section-two">
          <CardContainer
            aemCardContainerProps={cardCollectionOneAemProps}
            ratioProp={RatioPropEnum.SixteenToNine}
            cardType={CardTypeEnum.Ghost}
            className={'custom-class'}
          />
        </div>

        {/*section 3*/}
        <PageHeader aemHeaderProps={{ ...sectionThreeAemProps }} className="section-header" />
        <div className="section-two">
          <CardContainer
            aemCardContainerProps={updateCardCollectionTwoAemProps(cardCollectionTwoAemProps)}
            ratioProp={RatioPropEnum.SixteenToNine}
            cardType={CardTypeEnum.Ghost}
            buttonType={'secondary'}
            className={'custom-class'}
          />
        </div>
        {disclosureContainerAemProps && (
          <DisclosureContainer aemDisclosureContainerProp={disclosureContainerAemProps} />
        )}
      </ThemeProvider>
    )
  );
};

export default EULandingPageView;
